import { AnyAction } from 'redux';

import { UploadNotificationSound } from '@wetransfer/transfer/modules/upload-notifications/upload-notifications';
import { UploadNotificationActions } from '@wetransfer/transfer/store/action/upload-notifications';
import initialState from '@wetransfer/transfer/store/helper/upload-notifications';

export default function (
  state = initialState,
  action: AnyAction
): typeof initialState {
  const { type } = action;

  switch (type) {
    case UploadNotificationActions.SET_UPLOAD_NOTIFICATION_ACTIVE:
      return {
        ...state,
        active: action.payload,
      };

    case UploadNotificationActions.SET_UPLOAD_NOTIFICATION_SOUND:
      return {
        ...state,
        sound: action.payload as UploadNotificationSound,
      };

    default:
      return state;
  }
}
